import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ModalService } from '../services/modal/modal.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private notifying = false;

  constructor(
    private router: Router,
    private modalService: ModalService
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleError(error);
        return throwError(() => error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): void {
    if (this.notifying) return;

    const status = error.status;

    if (status === 0) {
      this.notify('fail', 'เชื่อมต่อไม่ได้', 'ไม่สามารถติดต่อเซิร์ฟเวอร์ได้ โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ต');
      return;
    }

    if (status === 401) {
      this.notify('fail', 'หมดเวลาเข้าใช้งาน', 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง');
      return;
    }

    if (status === 403) {
      this.router.navigate(['/forbidden']);
      return;
    }

    if (status >= 500) {
      this.notify('fail', 'เซิร์ฟเวอร์ขัดข้อง', `เกิดข้อผิดพลาดที่เซิร์ฟเวอร์ (${status})`);
      return;
    }

    if (status >= 400) {
      const message = (error.error && (error.error.message || error.error.error)) || error.message || 'คำขอไม่ถูกต้อง';
      this.notify('fail', 'เกิดข้อผิดพลาด', String(message));
    }
  }

  private notify(type: 'success' | 'fail' | 'info', title: string, content: string) {
    this.notifying = true;
    this.modalService.openModal(type, title, content).finally(() => {
      this.notifying = false;
    });
  }
}
